import { AdminModule } from '../../../modules/auth/models/user-auth.model';
import { OnInit, Directive } from '@angular/core';
import { UnSubscribable } from '@core/un-subscrible';

/**
 * Base class for components which provides a list view for one API source.
 * If the page component needs to show more than one list views,
 * implement two list components that inherit this base class
 */
@Directive()
// tslint:disable-next-line: directive-class-suffix
export abstract class EigBaseComponent extends UnSubscribable implements OnInit {
    adminModule: AdminModule;

    ngOnInit(): void {
    }
}
